<div [ngClass]="itemWrapperCssClasses()" #legendItemsContainer>
  <div *ngFor="let item of legendItems()" class="legend-item">
    <input type="checkbox" class="hidden-checkbox" [id]="item.header" hidden [ngModel]="item.enabled" (ngModelChange)="onActivationSateChanged(item)" />
    <label [attr.for]="item.header">
      <img class="legend-image" [attr.src]="item.iconUrl" />
      <p class="legend-text font-bold">{{ item.header }}</p>
    </label>
  </div>
</div>
